import React from "react";
import "./Footer.css";

import InstagramIcon from "../../assets/images/rrss/Instagram.svg";
import Xicon from "../../assets/images/rrss/X.svg";
import flecha from "../../assets/flecha-link.png";

function Footer() {
  return (
    <section className="footer-section">
      {/* Contact info div at top right */}
      <div className="contact-info">
        <p>info@laflamacasal.com</p>
        <p>c/ les Escoles nº12</p>
        <p>Cerdanyola del Vallès, 08290</p>
        <div className="social-icons">
          <a
            href="https://x.com/laflamacasal?lang=ca"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon twitter link-without-underline"
          >
            <img src={Xicon} alt="x icon" />
          </a>
          <a
            href="https://www.instagram.com/laflamacasal/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon instagram link-without-underline"
          >
            <img src={InstagramIcon} alt="instagram icon" />
          </a>
        </div>
      </div>

      <div className="footer-content">
        <a href="/contact" className="footer-link">
          CONTACTA
          <img src={flecha} alt="arrow" className="footer-arrow" />
        </a>

        {/* Terms links at bottom */}
        <div className="terms-links">
          <a href="#privacy" className="terms-link">
            POLÍTICA PRIVACITAT
          </a>
          <a href="#terms" className="terms-link">
            CONDICIONS D'ÚS
          </a>
        </div>
      </div>
    </section>
  );
}

export default Footer;
